import React from 'react';
import XtramMark from './XtramMark';

/**
 * "Xtram announces" icon: a brand-blue megaphone carrying the Xtram X, with
 * orange sound waves. Class hooks let the parent animate the body and waves.
 */
const ReleasesIcon = ({ size = 28, className, bodyClassName, waveClassName, waveInnerClassName, waveOuterClassName }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        aria-hidden="true"
        focusable="false"
    >
        <g className={bodyClassName}>
            {/* handle */}
            <path d="M9 20.2 10.9 26a1.5 1.5 0 0 0 1.42 1.03h1.24a1.05 1.05 0 0 0 .99-1.38L12.9 20.2Z" fill="#1d33c4" />
            {/* back cap */}
            <rect x="3.6" y="11.3" width="7.2" height="9.4" rx="2.4" fill="#304fff" />
            {/* cone */}
            <path d="M9.6 11.3 21.1 5.5a1.3 1.3 0 0 1 1.9 1.16v18.68a1.3 1.3 0 0 1-1.9 1.16L9.6 20.7Z" fill="#304fff" />
            {/* rim */}
            <rect x="21.7" y="4.6" width="2.8" height="22.8" rx="1.4" fill="#1d33c4" />
            {/* highlight */}
            <path d="M11 12.6 20.6 7.8" stroke="#ffffff" strokeOpacity="0.35" strokeWidth="1.1" strokeLinecap="round" fill="none" />
            <XtramMark x={12.1} y={11.7} size={8.6} warmColor="#f9aa2a" coolColor="#ffffff" />
        </g>
        <g className={waveClassName} fill="none" stroke="#f9aa2a" strokeLinecap="round">
            <path className={waveInnerClassName} d="M26.6 12.6q1.9 3.4 0 6.8" strokeWidth="1.9" />
            <path className={waveOuterClassName} d="M28.7 10.1q3.4 5.9 0 11.8" strokeWidth="1.7" />
        </g>
    </svg>
);

export default ReleasesIcon;
